<template>
  <div class="bg-gradient-to-r from-green-400 to-teal-200 min-h-screen">
    <main class="lg:relative shadow-xl">
      <div class="pt-16 pb-16 pl-10 mx-auto text-center lg:text-left">
        <div class="px-4 lg:w-1/2 sm:px-8 xl:pr-16">
          <h1 class="text-4xl tracking-tight font-extrabold text-green-700 mb-10 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl">
            <span class="block xl:inline">What skills </span>
            {{ ' ' }}
            <span class="block text-green-200 xl:inline">do you want to work on?</span>
          </h1>
          <div class="flex flex-col items-center">
            <div>
              <div class="relative flex items-start" v-for="skill in skillList" :key="skill.id">
                <div class="flex items-center h-5">
                  <input
                      id="skills"
                      name="skills"
                      type="checkbox"
                      class="focus:ring-green-700 h-4 w-4 text-green-600 border-green-400 rounded"
                      :value="skill.id"
                      v-model="selectedSkills"
                      @change="generateFilteredAppList"
                  />
                      <!-- todo CBs require @change !!!! -->
                </div>
                <div class="ml-3 text-sm">
                  <label for="offers" class="font-medium text-green-800 text-lg">{{ skill.skill }}</label>
                </div>
              </div>
            </div>
            <!--
            todo checking a checkbox will add a value to selectedSkills aray via v-model -->
            <!--  {{ selectedSkills }}-->
          </div>
        </div>
      </div>
      <div class="hidden lg:block relative w-full h-64 sm:h-72 md:h-96 lg:absolute lg:inset-y-0 lg:right-0 lg:w-1/2 lg:h-full">
        <img class="absolute inset-0 w-full h-full object-cover" src="https://images.unsplash.com/photo-1520333789090-1afc82db536a?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=2102&q=80" alt="" />
      </div>
    </main>
    <div class="px-10 py-8 lg:py-16 2xl:px-32">
      <ul class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
        <li v-for="app in filteredAppList" :key="app.id"
            class="col-span-1 flex flex-col text-center bg-green-100 rounded-lg shadow">
            <div class="bg-green-200 rounded-tl-lg rounded-tr-lg">
              <h3 class="py-4 text-green-900 text-lg lg:tex-xl font-medium">{{ app.app }}</h3>
            </div>
            <div class="flex-1 flex flex-col p-5">
                <dl class="mt-1 flex-grow flex flex-col justify-between">
                  <dt class="sr-only">Instructions</dt>
                  <dd class="text-gray-500 text-sm">{{ app.instructions }}</dd>
                  <dt class="sr-only">Skills</dt>
                  <dd class="mt-5 flex flex-wrap">
                    <span v-for="skill in app.skills" :key="skill.id"
                          class="px-2 py-1 text-green-800 text-xs font-medium bg-green-300 rounded-full mx-1 my-1">{{ skillList[skill-1].skill }}</span>
                  </dd>
              </dl>
            </div>
          <div class="pb-3 px-5 text-left">
            <div v-for="skill in app.skills" :key="skill.id">
              <div v-if="skillList[skill-1].options">
                <p class="text-xs" v-for="option in skillList[skill-1].options" :key="option">
                  {{ skillList[skill-1].skill }} -
                  <a :href="option" class="text-blue-500">{{ option }}</a>
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';

export default {
  name: "IdeaGeneratorApp",
  components: {
  },
  setup() {
    //const GENERATOR_BASE = 'process.env.VUE_APP_FIREBASE_API_URL';
    const GENERATOR_BASE = 'https://vue-http-demo-70033-default-rtdb.firebaseio.com';

    //skilss
    const skillList = ref([]);
    const selectedSkills = ref([]);

    //todo replace with axios
    async function getSkillList() {
      const response = await fetch(`${GENERATOR_BASE}/skills.json`);
      skillList.value = await response.json();
    }
    getSkillList();

    //filtered apps based on skills
    const filteredAppList = ref([]);
    let appList = []; //todo Because this value isn't being exposed in the template, you don't need it to be reactive.

    //todo replace with axioss
    async function getAppList() {
      const response = await fetch(`${GENERATOR_BASE}/apps.json`);
      appList = await response.json();
      filteredAppList.value = appList;
      //console.log(filteredAppList.value);
    }
    getAppList();

    //todo filter lists to get user selected apps
    function generateFilteredAppList() {
      //console.log(`cb checked ${selectedSkills.value}`);
      filteredAppList.value = [];

      for (const app of appList) {
        const appSkillsArray = app.skills;
        const selectedSkillsArray = selectedSkills.value;

        if (hasAllSkills(appSkillsArray, selectedSkillsArray)) {
          filteredAppList.value.push(app);
        }
      }
    }

    function hasAllSkills(appSkills, selectedSkills) {
      return selectedSkills.every(f => appSkills.includes(f));
        //todo .every() - The every() method tests whether all elements in the array pass the test implemented by the provided function. It returns a Boolean value.
        //todo .includes() - The includes() method determines whether an array includes a certain value among its entries. It returns true or false.
    }

    return {
      skillList,
      selectedSkills,
      filteredAppList,
      generateFilteredAppList,
    }
  }
}
</script>